import { createSelector } from 'reselect'

import apiAccessTypes from 'constants/apiAccessTypes'
import { fetchTicketingSystems } from 'api/ticketingSystems'

const cachedData = fetchTicketingSystems.select()

export const ticketingSystems = createSelector(
  cachedData,
  (cachedData) => {
    return cachedData?.data?.ticketingSystems || []
  }
)

export const isFetching = createSelector(
  cachedData,
  (cachedData) => {
    return (!cachedData || cachedData.status === 'pending')
  }
)

export const ticketingSystemsNotEmpty = createSelector(
  ticketingSystems,
  (ticketingSystems) => ticketingSystems.length > 0
)

export const ticketingSystemsDisplayIds = createSelector(
  ticketingSystems,
  (ticketingSystems) => ticketingSystems.map(ts => ts.displayId)
)

export const noTicketingSystemsWithApiAccess = createSelector(
  ticketingSystems,
  (ticketingSystems) => ticketingSystems.every(ts => ts.apiAccessDisplayName === apiAccessTypes.API_NO_ACCESS)
)

export const ticketingSystemsWithApiAccess = createSelector(
  ticketingSystems,
  (ticketingSystems) => ticketingSystems.filter(ts => ts.apiAccessDisplayName !== apiAccessTypes.API_NO_ACCESS)
)

// parametrized selector, in case of performance issues or re-renders use memoization
export const ticketingSystemDisplayIdById = (id) => (state) => {
  const ticketingSystems_ = ticketingSystems(state)

  const ticketingSystem = ticketingSystems_.find(ts => ts.id === id)
  return ticketingSystem?.displayId || null
}
